// Papel (role) real do agente logado, direto do WootDash — substitui a leitura de
// DashHeader.vue que usava useAdmin().profiles (perfil local Chatwoot, admin_config em
// localStorage, sem relação com o RBAC real do backend). Um agente com role "Sistema" no
// banco (config.role_permissions) mostrava "Agente" no cabeçalho porque aquele profile
// local nunca tinha ouvido falar do RBAC novo — corrigido lendo GET /agentes/{id} direto.
//
// Também decide o escopo: quem vê todas as conversas é quem tem a regra geral "geral.visaoTodos" no token
// (a mesma que o servidor aplica — ConversationVisibility), não mais o nome do perfil. Os demais ficam com o
// filtro de Time travado nos próprios times (GET /agentes/{id}/times); o servidor já só devolve o que podem ver.
import { ref, computed } from 'vue'
import { getAgent, listAgentTeams, type CpAgentTeamLink } from '@/services/wootdashAgents'
import { decodeJwtPermissions } from '@/utils/jwt'

/** Regra geral do perfil que libera todas as conversas (o servidor usa a mesma). */
export const SEE_ALL_PERMISSION = 'geral.visaoTodos'

const seesAll = ref(false)

const roleNames = ref<string[]>([])
const myTeams = ref<CpAgentTeamLink[]>([])
const loaded = ref(false)
let currentAgentId = ''

export function useCurrentAgentRole() {
  const roleLabel = computed(() => roleNames.value[0] ?? '')
  const isUnrestricted = computed(() => seesAll.value)
  const myTeamIds = computed(() => myTeams.value.map(t => t.id))
  return { roleNames, roleLabel, isUnrestricted, myTeams, myTeamIds, loaded }
}

/** Idempotente por agente — chamar de novo com o mesmo id não refaz a busca. */
export async function loadCurrentAgentRole(token: string, agentId: string): Promise<void> {
  // Token novo (login, renovação, "continuar logado") pode trazer regra nova — relê sempre, antes do atalho abaixo.
  seesAll.value = decodeJwtPermissions(token).includes(SEE_ALL_PERMISSION)
  if (!agentId || (currentAgentId === agentId && loaded.value)) return
  currentAgentId = agentId
  const [agent, teams] = await Promise.all([getAgent(token, agentId), listAgentTeams(token, agentId)])
  roleNames.value = agent?.roleNames ?? []
  myTeams.value = teams
  loaded.value = true
}

export function resetCurrentAgentRole(): void {
  currentAgentId = ''
  roleNames.value = []
  seesAll.value = false
  myTeams.value = []
  loaded.value = false
}
